import React from 'react';
import PropTypes from 'prop-types';
import { compose, graphql } from 'react-apollo';
import LocationPreference from 'components/LocationPreference';
import { LOCATION_DATA } from 'utils/constants';
import { getUserData } from 'utils/graphQLFunctions';
import { CHANGE_PREFERRED_LOCATION_MUTATION } from 'utils/graphql/patronQueries';
import { errorShape, userShape } from 'utils/shapes';

const ForcedLocationPreference = ({ userData, changePreferredLocation }) => {
  const userPreferredLocation = userData?.user?.preferredLocation;
  const isLocationValid = !!LOCATION_DATA[userPreferredLocation];

  const { loading, error } = userData;
  if (loading || error || isLocationValid) {
    return null;
  }

  return (
    <LocationPreference
      show={!isLocationValid}
      user={userData.user}
      onSelectPreference={changePreferredLocation}
      backdrop={'static'}
      title={'Preferred Property'}
      label={
        "Please select your preferred Wind Creek location to view that location's WStore! Your preferred property will also show you relevant events and promotions for that location."
      }
    />
  );
};

ForcedLocationPreference.propTypes = {
  userData: PropTypes.shape({
    loading: PropTypes.bool,
    error: errorShape,
    user: userShape
  }),
  changePreferredLocation: PropTypes.func
};

export default compose(
  getUserData({
    name: 'userData'
  }),
  graphql(CHANGE_PREFERRED_LOCATION_MUTATION, {
    props: ({ ownProps, mutate }) => ({
      changePreferredLocation: location =>
        mutate({
          variables: { input: { preferredLocation: location } }
        })
    })
  })
)(ForcedLocationPreference);
